import React from "react";
import { useLanguage } from "../../../contexts/LanguageContext";

export function ExportLoadingOverlay({ show }) {
  const { t } = useLanguage();
  if (!show) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="flex flex-col items-center gap-4 p-8 bg-slate-800/90 rounded-2xl border border-white/10">
        <div className="w-10 h-10 rounded-full border-2 border-white/20 border-t-orange-500 animate-spin" />
        <p className="text-white font-medium text-sm">
          {t("exportInProgress")}
        </p>
      </div>
    </div>
  );
}
